import { generatePath, matchPath } from "react-router-dom";

export default class CollectionLink {
  constructor(merchantId, name, icon, path, authenticationName, subLinks, subtitle) {
    this.merchantId = merchantId;
    this.name = name;
    this.icon = icon;
    this.path = path;
    this.subLinks = subLinks;
    this.authenticationName = authenticationName;
    this.subtitle = subtitle;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId });
  }

  match(pathname) {
    return matchPath(pathname, { path: this.getLink() });
  }
}
